// extracted by mini-css-extract-plugin
export const root = "faq-item-module--root--3jy4L";
export const question = "faq-item-module--question--ycSUV";
export const answer = "faq-item-module--answer--3-wqc";